import React from "react";
import "./demo-request.css";

const DemoRequestForm = ({
  title = "Request A Free Demo",
  buttonText = "Send",
  onSubmit,
}) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    if (onSubmit) onSubmit(e);
  };

  return (
    <section className="demo-request">
      <div className="container">
        <h2 className="clients-title">{title}</h2>

        <form className="demo-form" onSubmit={handleSubmit}>
          <div className="demo-field">
            <input type="text" required />
            <label>Name *</label>
          </div>

          <div className="demo-field">
            <input type="email" required />
            <label>Email *</label>
          </div>

          <div className="demo-field phone-field">
            <span className="country-code">🇮🇳 +91</span>
            <input type="tel" required />
            <label>Phone *</label>
          </div>

          <button type="submit" className="main-btn me-5">
            {buttonText}
          </button>
        </form>
      </div>
    </section>
  );
};

export default DemoRequestForm;
